import React, { useState } from 'react'

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Input,
  ListItemButton,
  ListItemText,
  List as MuiList,
} from '@mui/material'
import { useAgencyAccountLink } from 'features/agencies/hooks/useAgencyAccountLink'
import PlanBadge from 'features/customers/components/PlanBadge'
import { useCustomers } from 'features/customers/hooks/useCustomers'

import debounceEventHandler from 'utils/debounceEventHandler'

type AddSubAccountProps = {
  open: boolean
  onClose: (...args: any[]) => any
}

const AddSubAccount = ({ onClose, open }: AddSubAccountProps) => {
  const [search, setSearch] = useState('')
  const [selected, setSelected] = useState<number | null>(null)

  const { data: customers } = useCustomers({ filters: { search } })
  const { mutateAsync: linkAccount } = useAgencyAccountLink()

  const handleSearchChange = (event: any) => setSearch(event.target.value)
  const handleAdd = async () => selected && linkAccount(selected)

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>
        <Box sx={{ display: 'flex' }}>
          Add a new subaccount
          <Input
            onChange={debounceEventHandler(handleSearchChange, 300)}
            placeholder="Search..."
            sx={{ ml: 'auto', fontWeight: 400 }}
          />
        </Box>
      </DialogTitle>

      <DialogContent style={{ width: 500 }}>
        <MuiList>
          {(customers?.items || []).map((customer, index) => (
            <ListItemButton key={index} onClick={() => setSelected(customer.id)} selected={customer.id === selected}>
              <ListItemText
                primary={`${customer.name}`}
                secondary={
                  <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    Website: {customer.website}
                    <PlanBadge name={customer.plan?.name} />
                  </Box>
                }
              />
            </ListItemButton>
          ))}
        </MuiList>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button disabled={!selected} onClick={handleAdd}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddSubAccount
